import React from "react";
import { Link } from "react-router-dom";
import { formatCurrency, siteConfig } from "../config/siteConfig";
import "../css/privacy.scss";

function Faqs() {
  return (
    <main id="main-content" className="privacy-page">
      <header className="privacy-page__header"><p className="privacy-page__eyebrow">Help</p><h1>Frequently asked questions</h1><p>Useful information about ordering from {siteConfig.brandName}.</p></header>
      <div className="privacy-page__body">
        <section><h2>How much is delivery?</h2><p>Tracked delivery is {formatCurrency(siteConfig.shipping.standard)} per order. Available destinations appear at checkout.</p></section>
        <section><h2>When will my order be dispatched?</h2><p>{siteConfig.shipping.dispatch}. Tracking is emailed when the parcel leaves our facility.</p></section>
        <section><h2>Which payments do you accept?</h2><p>Our secure payment provider supports major cards and available digital wallets. Payment details are entered on its hosted page, not stored by us.</p></section>
        <section><h2>Can I return an item?</h2><p>Eligible unused items may be returned after contacting us within 14 days of delivery. Read the <Link to="/returns">returns policy</Link> for conditions.</p></section>
        <section><h2>How can I contact you?</h2><p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>. Email is our customer-support channel.</p></section>
      </div>
    </main>
  );
}

export default Faqs;
